(() => {
  if (window.couponCopyInitialized) return;
  window.couponCopyInitialized = true;

  const FEEDBACK_MS = 1800;
  const SLOT_SELECTOR = '[data-first-purchase-coupon-slot]';
  let liveRegion = null;

  const announce = (message) => {
    if (!message) return;
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'status');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    // A new text node after clearing makes screen readers announce repeated messages too.
    setTimeout(() => {
      liveRegion.textContent = message;
    }, 50);
  };

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand('copy');
    field.remove();
    if (!copied) throw new Error('copy failed');
  };

  const showFeedback = (button) => {
    const label = button.querySelector('[data-copy-coupon-label]');
    const hint = button.closest('[data-coupon-box]')?.querySelector('[data-copy-coupon-hint]');
    const copiedText = button.dataset.copiedText || 'Copiado!';
    const targets = [label, hint].filter(Boolean);

    // Keep the code chip width while it shows the shorter/longer feedback text, so the line does not jump.
    if (label && !label.style.minWidth) label.style.minWidth = `${label.getBoundingClientRect().width}px`;
    if (label) label.style.display = 'inline-block';

    targets.forEach((el) => {
      if (!el.dataset.originalText) el.dataset.originalText = el.textContent;
      el.textContent = el === hint ? hint.dataset.copiedHint || copiedText : copiedText;
    });
    button.classList.add('is-copied');
    announce(button.dataset.copiedAnnouncement || `${button.dataset.copyCoupon}: ${copiedText}`);

    clearTimeout(button.couponCopyTimer);
    button.couponCopyTimer = setTimeout(() => {
      targets.forEach((el) => {
        el.textContent = el.dataset.originalText;
      });
      button.classList.remove('is-copied');
    }, FEEDBACK_MS);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-copy-coupon]');
    if (!button) return;
    const code = button.dataset.copyCoupon;
    if (!code) return;

    copyText(code)
      .then(() => showFeedback(button))
      .catch(() => {
        // Clipboard blocked: the code stays visible on screen, so there is nothing else to do.
      });
  });

  // Product page: the theme swaps the price container on variant change; copy its coupon template into the slot.
  const syncSlot = (slot) => {
    const source = document.getElementById(slot.dataset.firstPurchaseCouponSlot);
    if (!source) return;
    slot.replaceChildren(source.content.cloneNode(true));
  };

  const watchedContainers = new WeakSet();

  const watchSlot = (slot) => {
    const source = document.getElementById(slot.dataset.firstPurchaseCouponSlot);
    const container = source?.parentElement;
    if (!container || watchedContainers.has(container)) return;
    watchedContainers.add(container);
    new MutationObserver(() => syncSlot(slot)).observe(container, { childList: true });
  };

  const initSlots = (root = document) => {
    root.querySelectorAll(SLOT_SELECTOR).forEach(watchSlot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSlots());
  } else {
    initSlots();
  }
  document.addEventListener('shopify:section:load', (event) => initSlots(event.target));
})();
